/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 客戶資料頁面
 * @module CustomerContainer
 */

// ----- import from local libraries -----
import {React} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import {useDispatch} from 'react-redux';
import {Modal as BSModal} from 'bootstrap';
import CustomerPage from './components/CustomerPage';
import enumList from 'web/utils/enumList';
import {AlertModal} from 'web/components/modal/AlertModal';
import {useAlertModal} from 'web/components/modal/hooks/useAlertModal';
import {useEffect, useRef, useState} from 'react';
import {editCustomerStatus} from 'web/redux/actions/CustomerActions';
import {showMessage} from 'web/utils/modalHelper';
import CustomerModal from './components/CustomerModal';
import MachineAssignmentListModal from './components/MachineAssignmentListModal';
import {getDefaultCustomerItem} from './hooks/useCustomer';

// ----- constants and enums -----

const CustomerContainer = (props) => {
  const dispatch = useDispatch();
  const [customerModalMode, setCustomerModalMode] = useState(
    enumList.modalMode.new,
  );
  const [needCustomerLoad, setNeedCustomerLoad] = useState(false);
  const [machineAssignmentCustomerData, setMachineAssignmentCustomerData] =
    useState({});

  const machineAssignmentListModalRef = useRef();
  const machineAssignmentListModalObjRef = useRef();
  const [customerItem, setCustomerItem] = useState({
    customerCode: '',
    customerName: '',
    address: '',
    contactName: '',
    contactPhone: '',
    faxId: '',
    memo: '',
  });

  const customerModalRef = useRef(null);
  const customerModalObjRef = useRef(null);

  const {
    alertRef,
    actionType,
    actionMode,
    actionIds,
    alertMessage,
    setAlertMessage,
    setActionMode,
    setActionIds,
    setActionType,
    toggleAlertModal,
  } = useAlertModal();

  useEffect(() => {
    if (customerModalRef.current && !customerModalObjRef.current) {
      customerModalObjRef.current = new bootstrap.Modal(customerModalRef.current);
    }
  }, [customerModalRef]);

  // const setCustomerModalRef = (element) => {
  //   if (element && !customerModalRef.current) {
  //     customerModalRef.current = new bootstrap.Modal(element);
  //   }
  // };

  const handleEditCustomerStatus = (customerCodes, status) => {
    dispatch(editCustomerStatus({customerCodes, status}))
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode && statusCode.isSuccessCode()) {
          setNeedCustomerLoad(true);
          showMessage(enumList.messageModalMode.info, '更新成功');
          toggleAlertModal(false);
        } else {
          showMessage(enumList.messageModalMode.error, res);
          toggleAlertModal(false);
        }
      })
      .catch((err) => {
        showMessage(enumList.messageModalMode.error, err);
        console.error('updateCustomerStatus error', err);
      });
  };

  const onConfirm = () => {
    const customerCodes = actionIds;
    const status =
      actionMode === enumList.alertModalModeEnums.enable
        ? enumList.flgStatus.active
        : enumList.flgStatus.inactive;

    if (
      actionMode === enumList.alertModalModeEnums.enable ||
      actionMode === enumList.alertModalModeEnums.disable
    ) {
      handleEditCustomerStatus(customerCodes, status);
    }
  };

  const toggleCustomerAddModal = (isShow) => {
    setCustomerModalMode(enumList.modalMode.new);
    setCustomerItem(getDefaultCustomerItem());
    if (customerModalObjRef.current) {
      if (isShow) {
        customerModalObjRef.current.show();
      } else {
        customerModalObjRef.current.hide();
      }
    }
  };

  const toggleCustomerEditModal = (isShow, customerItem) => {
    setCustomerModalMode(enumList.modalMode.edit);
    setCustomerItem(customerItem);
    if (customerModalObjRef.current) {
      if (isShow) {
        customerModalObjRef.current.show();
      } else {
        customerModalObjRef.current.hide();
      }
    }
  };

  const toggleMachineAssignmentListModal = (type) => {
    if (!(machineAssignmentListModalObjRef.current instanceof BSModal)) {
      console.log('errrrrrrrrrr');
      return;
    }
    switch (type) {
      case 'show':
        return machineAssignmentListModalObjRef.current.show();
      case 'hide':
        return machineAssignmentListModalObjRef.current.hide();
      default:
        return machineAssignmentListModalObjRef.current.toggle();
    }
  };

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <CustomerPage
            {...props}
            setMachineAssignmentCustomerData={setMachineAssignmentCustomerData}
            toggleCustomerAddModal={toggleCustomerAddModal}
            toggleCustomerEditModal={toggleCustomerEditModal}
            toggleMachineAssignmentListModal={toggleMachineAssignmentListModal}
            onBatchHandle={(mode, message, customerCodes) =>
              toggleAlertModal(
                true,
                mode,
                enumList.targetAction.customer,
                message,
                customerCodes,
              )
            }
            needCustomerLoad={needCustomerLoad}
            setNeedCustomerLoad={setNeedCustomerLoad}
          />
        </div>
        <Footer />
      </div>
      <AlertModal
        ref={alertRef}
        mode={actionMode}
        message={alertMessage}
        onConfirm={() => onConfirm()}
        onCancel={() => setNeedCustomerLoad(true)}
      />
      <CustomerModal
        {...props}
        ref={customerModalRef}
        mode={customerModalMode}
        customerItem={customerItem}
        clearCustomerItem={() => setCustomerItem(null)}
        toggleCustomerAddModal={toggleCustomerAddModal}
        toggleCustomerEditModal={toggleCustomerEditModal}
        reloadDepartmentList={() => {
          setNeedCustomerLoad(true);
        }}
        onErrorHandle={(title, message) =>
          showMessage(true, enumList.messageModalMode.error, title, message)
        }
      />
      <MachineAssignmentListModal
        ref={machineAssignmentListModalRef}
        {...props}
        modalRef={machineAssignmentListModalObjRef}
        customerData={machineAssignmentCustomerData}
        setCustomerData={setMachineAssignmentCustomerData}
      />
    </>
  );
};

export default CustomerContainer;
